import React, { useState, CSSProperties, useEffect, useRef } from "react";
import MaterialSwatch from "../components-generic/MaterialSwatch";
import { styled, ThemeProvider } from "@mui/material/styles";
import theme from '../Styles/MuiTheme';
import materialDataLookup from '../components-special/MaterialDataLookup.jsx'
import { Grid, Divider, IconButton } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";


import Typography from '@mui/material/Typography';
import SwiperCore from 'swiper';
import  { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import '../Styles/styles.css';

const StyledDiv = styled('div')(({theme}) => ({
    root: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
      },
    },
  }));

const arrowStyles = {
// const arrowStyles: CSSProperties = {
    position: 'absolute',
    zIndex: 2,
    top: 'calc(50% - 15px)',
    width: 30,
    height: 30,
    cursor: 'pointer',
};

const indicatorStyles = {
// const indicatorStyles: CSSProperties = {
    background: '#fff',
    width: 8,
    height: 8,
    display: 'inline-block',
    margin: '0 8px',
};

const calcCenterPercentage = (total, center) => {
  console.log("total: ", center, total)

    let centerPercentage = center * 100 / total;
    if (center >10) {
      centerPercentage = 25;
    }

    console.log("centerPercentage: ", centerPercentage)

    return centerPercentage;
};

export default function MaterialMenu(props) {
  const { getProps, paramData, getValue } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [swiper, setSwiper] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getMaterials = getProps("Material");

  const menuItems = getMaterials.children.reduce((acc, choice) => {
    const material = materialDataLookup(choice.props.children);
    const finishType = material.finishType;
    const existingRow = acc.find(row => row.finishType === finishType);
    // console.log("existingRow: ", existingRow, acc.length);
    const swatch = (
      <StyledDiv onClick={handleClick}>
        <MaterialSwatch
          name={choice.props.children}
          source={material.imageUrl}
          idx={material.index} // use getKey to get unique key
          // idx={acc.length}
          {...getProps("Material")}
        />
      </StyledDiv>
    );
    if (existingRow) {
      // console.log("existingRow: ", existingRow);
      existingRow.swatches.push(swatch);
    } else {
      // console.log("new row: ", finishType);
      acc.push({ finishType, swatches: [swatch] });
    }
    return acc;
  }, []).slice((page - 1) * rowsPerPage, page * rowsPerPage).map((row, idx) => (
  // }, []).slice((page - 1) * rowsPerPage, page * rowsPerPage).map((row, idx) => (
    <React.Fragment key={idx}>
{/* <div key={idx}> */}
      <Grid container item xs={12} justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="subtitle1" align="left" sx={{ display: 'flex', alignItems: 'center' }}>{row.finishType}</Typography>
        </Grid >
         <Grid  item xs={12} sx={{ alignItems: 'center' }}>
          <Swiper
            onSwiper={setSwiper}
            slidesPerView={3}
            // spaceBetween={5}
            // centeredSlides={true}
            // centeredSlidesBounds={true}
            // centeredSlidesBounds={true}
            // centeredSlidesBounds={calcCenterPercentage(3, 2)}
            // centeredSlidesBounds={calcCenterPercentage(3, 3)}
            // centerInsufficientSlides={true}

            // navigation={{
            //   prevEl: '.swiper-button-prev',
            //   nextEl: '.swiper-button-next',
            // }}
            // navigation={{
            //   //want to adjust the space between the arrows and the swatches
            //   prevEl: '.swiper-button-prev',
            //   nextEl: '.swiper-button-next',
            // }}
            navigation={true} 
            modules={[Navigation]} 
            className="mySwiper"
          >
            {row.swatches.map((swatch, index) => (
              <SwiperSlide key={index}>
                <div>
                  {swatch}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

            <Divider />

        </Grid>
      </Grid>
      {/* </div> */}
    </React.Fragment>
  ));

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 50));
    setPage(1);
  };

  useEffect(() => {
    SwiperCore.use([Navigation]);
  }, []);

  return (
    <div>
      <ThemeProvider theme={theme}>
        <Grid container direction="row" spacing={2} justify="center" alignItems="center">
          <Grid item xs={12}>
            <Grid container direction="row" spacing={1} justify="center" alignItems="center">
              {menuItems}
            </Grid>
          </Grid>
          {/* <Grid container item xs={12} justifyContent="space-between" alignItems="center">
            <Grid item>
              <IconButton onClick={() => setPage(page - 1)} disabled={page === 1}>
                <ArrowBackIos />
              </IconButton>
            </Grid>
            <Grid item>
              <IconButton onClick={() => setPage(page + 1)} disabled={page === Math.ceil(getMaterials.children.length / rowsPerPage)}>
                <ArrowForwardIos />
              </IconButton>
            </Grid>
          </Grid> */}
        </Grid>
      </ThemeProvider>
    </div>
  );
}
